export interface IReportData {
  id: string
  name: string
}